import React, { createContext, useState } from 'react';

export const AlertSearchContext = createContext();

export const AlertSearchProvider = (props) => {

    const [searchValue, setSearchValue] = useState('');

    return (
        <AlertSearchContext.Provider value={{ searchValue, setSearchValue }}>
            {props.children}
        </AlertSearchContext.Provider>
    );
}
